import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';
import { Element } from '@americanexpress/aqx-components';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { scrollToElement, updateFilterOnWindowHistory } from './utils';
import { getFilterData, getFilterCardCountHash } from './redux';
import {
  getActiveFilter,
  dispatchUpdateActiveFilter,
  getActiveFilterLabel
} from 'src/universal/redux/cardsFilter';
import {
  getG174FilterData,
  isG174Experiment,
  getG174FilterCardCountHash
} from 'src/universal/components/Experiments/G174/redux';
import EnhancedFilter from './EnhancedHorizontalFilter';
import { isWinOS } from 'core_modules/bootstrap/browsers/browser-detection';
import { isAndroidDevice } from 'core_modules/bootstrap/browsers/browser-detection.js';
import styles from './__styles__/index.scss?modules';

const VacFilter = ({
  bauFilterData,
  activeFilter,
  updateActiveFilter,
  cardCntHash,
  containerRef,
  activeFilterText,
  g174FilterData,
  isG174,
  g174CardCount
}) => {
  const filterData = isG174 ? g174FilterData : bauFilterData;
  const cardCount = isG174 ? g174CardCount : cardCntHash;

  const outerRef = useRef(null);

  useEffect(
    () => {
      setTimeout(() => {
        if (isG174) {
          updateActiveFilter({
            id: 'recommended',
            text: 'Recommended'
          });
          updateFilterOnWindowHistory(undefined);
        }
      }, 150);
    },
    [isG174]
  );

  const createItemOnClick = filterItem => {
    return () => {
      updateActiveFilter({
        id: filterItem.internalId,
        text: filterItem.text
      });

      setTimeout(() => {
        scrollToElement(containerRef.current);
        if (filterItem.internalId === 'recommended') {
          updateFilterOnWindowHistory(undefined);
        } else {
          const filter =
            filterItem?.internalId === 'all-cards'
              ? undefined
              : filterItem?.internalId;
          updateFilterOnWindowHistory(filter);
        }

        sendDTMClickEvent({
          eventAction: 'Click',
          eventType: 'pageInteraction',
          eventAsset: filterItem.internalId
        });
      }, 150);
    };
  };

  const {
    title,
    subTitle,
    sortedList = [],
    allCardsVACFilterText,
    selectedVACFilterText
  } = filterData;
  const updatedSubTitle = replaceStringWithVars({
    varsObject: {
      cardCnt: cardCount[activeFilter] || ''
    },
    string: subTitle
  });

  sortedList.forEach(item => {
    item.onClick = createItemOnClick(item);
  });

  const filterProps = {
    filterData,
    activeFilter
  };

  const voiceOverFilter = activeFilterText => {
    if (activeFilterText === 'All Cards') {
      return replaceStringWithVars({
        varsObject: {
          filter: activeFilterText || ''
        },
        string: allCardsVACFilterText
      });
    }
    return replaceStringWithVars({
      varsObject: {
        filter: activeFilterText || ''
      },
      string: selectedVACFilterText
    });
  };

  return (
    <div
      ref={outerRef}
      className={clsx(styles.filterOuter, styles.carousel, {
        [styles.isWinOS]: isWinOS(),
        [styles.isAndroidDevice]: isAndroidDevice()
      })}
    >
      <Element className={styles.filterInner}>
        <Element className={styles.headerSection} Component="div">
          <span className={styles.title}>{title}</span>
          <span className={styles.subTitle}>{updatedSubTitle}</span>
          <span aria-live="polite" className={styles.sr_only}>
            {voiceOverFilter(activeFilterText)}
          </span>
        </Element>
        <EnhancedFilter {...filterProps} />
        <div className={styles.carouselDivider} />
      </Element>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    updateActiveFilter: activeFilter => {
      dispatchUpdateActiveFilter(dispatch, { activeFilter });
    }
  };
};

const mapStateToProps = state => ({
  bauFilterData: getFilterData(state),
  activeFilter: getActiveFilter(state),
  cardCntHash: getFilterCardCountHash(state),
  activeFilterText: getActiveFilterLabel(state),
  g174FilterData: getG174FilterData(state),
  isG174: isG174Experiment(state),
  g174CardCount: getG174FilterCardCountHash(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(VacFilter));
